import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors } from '@naf-simba/theme';
import { isNotTransientProp } from '../../../lib/shouldForwardProp';

export const BaseTabHeaderButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: transparent;
  cursor: pointer;
  border: 2px solid transparent;
  border-bottom: 3px solid transparent;
  color: ${nafColor.neutral.neutral5};
  flex-shrink: 0;
  flex-basis: max-content;

  &:hover {
    color: ${nafColor.signature.black};
    border-bottom-color: ${nafColor.neutral.neutral5};
    outline: 0;
    letter-spacing: inherit;
  }

  ${({ $active }) =>
    $active
      ? css`
          color: ${nafColor.signature.black};
          font-weight: 600;
          border-bottom-color: ${colors.secondary[300]};
          letter-spacing: inherit;
        `
      : ''}

  &:focus:not(:disabled)[type='button'] {
    color: ${nafColor.signature.black};
    font-weight: 600;
    border-color: ${nafColor.neutral.neutral5};
    border-radius: 2px;
    letter-spacing: inherit;
    outline: none;
  }
`;

export const RightTabHeaderButton = styled(BaseTabHeaderButton, { shouldForwardProp: isNotTransientProp })<{
  $isLeftColumn: boolean;
  $active: boolean;
}>`
  display: ${({ $isLeftColumn, $active }) => ($isLeftColumn && !$active ? 'none' : 'initial')};

  @media (width <= calc(${breakpoints.xl} + 9px)) {
    display: initial;
  }
`;

export const TabHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  overflow-y: hidden;
  column-gap: ${spacing.space24};
  height: 50px;
  margin-bottom: -1px;
`;

export const HeaderBorder = styled.div`
  height: 49px;
  border-bottom: 1px solid ${nafColor.neutral.neutral2};
  min-width: max-content;
  width: 100%;
`;

export const ScrollContainer = styled.div`
  display: flex;
  margin: 0 -${spacing.space40};
  padding: 0 ${spacing.space40};
  box-sizing: border-box;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${breakpoints.m}) {
    width: 100vw;
    margin: 0 -${spacing.space24};
    padding: 0 ${spacing.space24};
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  row-gap: ${spacing.space80};
  margin: ${spacing.space40} 0 ${spacing.space64} 0;

  @media (max-width: ${breakpoints.m}) {
    max-width: calc(100vw - 48px);
  }
`;
